import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import { tipoImpressaoCupom } from '../../util/constantsUtil';

export default class ModalImpressaoMapaViagemItinerario extends Component {

    recuperarNomeArquivo(){
        if(this.props.referencias.get(this.props.referenciaSelecionada)){
          return this.props.referencias.get(this.props.referenciaSelecionada).nomeParaImpressao
        }
    }

    exibirBotaoImprimir () {
        if (this.props.tipo === tipoImpressaoCupom.normal) {           
            return (
                <button disabled={!this.props.pagina}
                    onClick={() => this.props.pagina.print()}
                    className="btn btn-laranja">IMPRIMIR</button>
            )
        }
  
        if (this.props.tipo === tipoImpressaoCupom.termica) {            
            return (
                <React.Fragment>
                  <ReactToPrint
                    trigger={() => <button disabled={!this.props.referenciaSelecionada}
                                           className="btn btn-laranja">IMPRIMIR
                    </button>}
                        content={() => this.props.referencias.get(this.props.referenciaSelecionada).referencia.current}
                        documentTitle={this.recuperarNomeArquivo()} />
                </React.Fragment>)
        }
  
        return ''
      }

    limparTudo() {        
        this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal);
        this.props.habilitarDesabilitarModalReciboCupom(false);
    }

    render() {
        return (
            <div className="modal fade show" id='modalImpressaoMapaViagemItinerario' role='dialog'
             aria-labelledby='modalImpressaoMapaViagemItinerario' aria-hidden='true' data-backdrop='static'>
          <div className={'modal-dialog modal-dialog-centered modal-md'}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Selecione o tipo de impressão que deseja</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => this.limparTudo()}>
                  <i className="material-icons">
                    &#xe5cd;
                  </i>
                </button>
              </div>
              <div className="modal-body">                
                <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.normal)}
                    checked={this.props.tipo === tipoImpressaoCupom.normal} /> Normal <br/>
                <input type="radio" onChange={() => this.props.setTipoImpressaoCupom(tipoImpressaoCupom.termica)}
                    checked={this.props.tipo === tipoImpressaoCupom.termica}/> Térmica                
              </div>
              <div className="modal-footer">
                {this.exibirBotaoImprimir()}
              </div>
            </div>
          </div>
        </div>
        )
    }
}